// $(document).ready(function () {
//   function handleCollapsible() {
//     $('body').off('click.collapsible'); 
//     if ($(window).width() > 768) {
//       $('body').on('click.collapsible', '.Collapsible__Button, .plus, .minus', function (e) {
//         e.preventDefault();
//         let $targetButton = $(this).closest('.custom_plus_minus').find('.Collapsible__Button');
//         let $inner = $targetButton.closest('.custom_plus_minus').next();
//         let $plus = $targetButton.parent().find('.plus');
//         let $minus = $targetButton.parent().find('.minus');
//         if ($inner.is(':visible')) {
//           $inner.hide();
//           $plus.show();
//           $minus.hide();
//         } else {
//           $inner.show();
//           $plus.hide();
//           $minus.show();
//         }
//       });
//     }
//   }
//   handleCollapsible();
//   $(window).on('resize', handleCollapsible); 
// });

$(document).ready(function () {
function handleCollapsible() {
  $('body').off('click.collapsible'); 
  $('body').on('click.collapsible', '.Collapsible__Button, .plus, .minus', function (e) {
    e.preventDefault();
    let $targetButton = $(this).closest('.custom_plus_minus').find('.Collapsible__Button');
    let $inner = $targetButton.closest('.custom_plus_minus').next();
    let $plus = $targetButton.parent().find('.plus');
    let $minus = $targetButton.parent().find('.minus');
    if ($inner.is(':visible')) {
      $inner.hide();
      $plus.show();
      $minus.hide();
    } else {
      $inner.show();
      $plus.hide();
      $minus.show();
    }
  });
}
handleCollapsible();
$(window).on('resize', handleCollapsible); 
});

//Started color swatches code

function initVariantSwatches() {
const containers = document.querySelectorAll('.variant-swatches-container');
containers.forEach(container => {
  if (container.dataset.swatchesInit === 'true') return;
  container.dataset.swatchesInit = 'true';

  const swatches = container.querySelector('.swatches');
  const prev = container.querySelector('.prev');
  const next = container.querySelector('.next');

  if (!swatches || !prev || !next) return;

  const swatchWidth = 40;
  const visibleSwatches = 5;
  let scrollPosition = 0;

  prev.addEventListener('click', () => {
    scrollPosition -= swatchWidth;
    if (scrollPosition < 0) scrollPosition = 0;
    swatches.style.transform = `translateX(-${scrollPosition}px)`;
  });

  next.addEventListener('click', () => {
    const maxScroll = swatches.scrollWidth - (swatchWidth * visibleSwatches);
    scrollPosition += swatchWidth;
    if (scrollPosition > maxScroll) scrollPosition = maxScroll;
    swatches.style.transform = `translateX(-${scrollPosition}px)`;
  });
});
}
initVariantSwatches(); 
const observer = new MutationObserver(() => {
initVariantSwatches();
});

observer.observe(document.body, {
childList: true,
subtree: true
});

//image slide animations code 
$(function () {
  function initSlick($slider) {
    if (!$slider.length || $slider.hasClass('slick-initialized')) return;
    $slider.slick({
      arrows: true,
      infinite: false,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 400,
      autoplay: false,
      adaptiveHeight: true,
      prevArrow: '<button type="button" class="slick-prev">‹</button>',
      nextArrow: '<button type="button" class="slick-next">›</button>'
    });
    const $wrapper = $slider.closest('.ProductItem__ImageWrapper');
    let userInteracted = false;
    $slider.on('click', '.slick-arrow', () => userInteracted = true);
    $wrapper.off('mouseenter mouseleave').on('mouseenter', function () {
      if (!userInteracted) $slider.slick('slickGoTo', 1);
    }).on('mouseleave', function () {
      if (!userInteracted) $slider.slick('slickGoTo', 0);
    });
    $slider.on('afterChange init', function (e, slick, current) {
      const total = slick.$slides.length;
      $slider.find('.slick-prev').prop('disabled', !current);
      $slider.find('.slick-next').prop('disabled', current === total - 1);
      if (e.type === 'init' && total <= 1)
        $slider.find('.slick-prev, .slick-next').prop('disabled', true);
    });
  }
  function initAllSliders() {
    $('.product-slick').each(function () {
      const $this = $(this);
      if (!$this.data('original-slides')) {
        $this.data('original-slides', $this.html());
      }
      initSlick($this);
    });
  }
  let debounceTimer;
  function reInitAfterAjax() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      initAllSliders();
    }, 500);
  }
  initAllSliders();
  const observer = new MutationObserver(() => reInitAfterAjax());
  const container = document.querySelector('.collection__product-grid') || document.body;
  observer.observe(container, { childList: true, subtree: true });
  $(document).on('change', '.Linklist__Checkbox', function () {
    reInitAfterAjax();
  });
  $(document).on('shopify:section:load ajaxComplete', function () {
    reInitAfterAjax();
  });
 $(document).on('click', '.color-swatch', function (e) {

  e.preventDefault();
  e.stopPropagation();

  const $swatch = $(this);

  console.log('================================');
  console.log('🟢 SHADE CLICKED');

  /*
   * Selected shade
   */
  const selected = ($swatch.attr('title') || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-');

  console.log('🎨 Selected Shade:', selected);


  /*
   * Find nearest parent which contains product-slick
   */
  const $sliderParent = $swatch.parents().filter(function () {
    return $(this).find('.product-slick').length > 0;
  }).first();


  console.log('📦 Slider Parent:', $sliderParent[0]);


  if (!$sliderParent.length) {

    console.log('❌ No parent containing .product-slick found');

    /*
     * Debug parent structure
     */
    console.log('🔍 Swatch parent:', $swatch.parent()[0]);
    console.log('🔍 Swatch grand parent:', $swatch.parent().parent()[0]);
    console.log('🔍 All parents:', $swatch.parents().toArray());

    return;
  }


  /*
   * Find slider
   */
  const $slider = $sliderParent.find('.product-slick').first();

  console.log('🎞️ Product Slider:', $slider[0]);


  if (!$slider.length) {

    console.log('❌ Product slider not found');

    return;
  }


  /*
   * Destroy Slick
   */
  if ($slider.hasClass('slick-initialized')) {

    try {

      $slider.slick('unslick');

      console.log('🔄 Slick destroyed');

    } catch (error) {

      console.log('⚠️ Slick destroy error:', error);

    }

  }


  /*
   * Restore original slides
   */
  const originalSlides = $slider.data('original-slides');

  if (!originalSlides) {

    console.log('❌ Original slides not found');

    return;
  }


  $slider.html(originalSlides);

  console.log('♻️ Original slides restored');


  /*
   * Find selected shade images
   */
  const $allSlides = $slider.children();

  let $matchingSlides = $();


  $allSlides.each(function (index) {

    const $slide = $(this);

    const $image = $slide.find('img').first();

    if (!$image.length) return;


    const alt = ($image.attr('alt') || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '-');


    console.log(
      '📸 Slide:',
      index,
      '| ALT:',
      alt,
      '| Selected:',
      selected,
      '| Match:',
      alt.includes(selected)
    );


    if (alt.includes(selected)) {

      $matchingSlides = $matchingSlides.add($slide);

    }

  });


  /*
   * No matching shade image
   */
  if (!$matchingSlides.length) {

    console.log(
      '❌ No matching image found for:',
      selected
    );

    return;
  }


  console.log(
    '✅ Matching shade images:',
    $matchingSlides.length
  );


  /*
   * Remove other shade images
   */
  $allSlides.each(function () {

    if (!$matchingSlides.is(this)) {

      $(this).remove();

    }

  });


  /*
   * Make first matching image the HERO
   */
  const $heroSlide = $slider.children().first();

  const $heroImage = $heroSlide.find('img').first();


  if ($heroImage.length) {

    let heroSrc =
      $heroImage.attr('src') ||
      $heroImage.attr('data-src');


    console.log(
      '🖼️ Selected HERO Image:',
      heroSrc
    );


    /*
     * Lazy image
     */
    if ($heroImage.attr('data-src')) {

      $heroImage.attr(
        'src',
        $heroImage.attr('data-src')
      );

      $heroImage.removeAttr('data-src');

      $heroImage.attr(
        'data-loaded',
        'true'
      );

    }

  }


  /*
   * Initialize Slick
   */
  initSlick($slider);

  console.log('🚀 Slick initialized');


  /*
   * Go to first image
   */
  if ($slider.hasClass('slick-initialized')) {

    $slider.slick(
      'slickGoTo',
      0,
      true
    );

    console.log(
      '🎯 HERO IMAGE SET:',
      selected
    );

  }


  /*
   * Active swatch
   */
  $sliderParent
    .find('.color-swatch')
    .removeClass('active-swatch');

  $swatch.addClass('active-swatch');


  /*
   * Update shade title
   */
  const titleValue = $swatch.attr('title');

  $sliderParent
    .find('.cstm-variant')
    .text(titleValue);


  console.log(
    '📝 Variant Title:',
    titleValue
  );

  console.log('================================');

});
/* =========================================================
   HOMEPAGE VARIANT SHADE IMAGE CHANGE
========================================================= */

// $(document).on('click', '.template-index .color-swatch', function (e) {

//   e.preventDefault();
//   e.stopPropagation();

//   const $swatch = $(this);

//   console.log('================================');
//   console.log('🟢 HOMEPAGE SHADE CLICKED');

//   const shadeTitle = ($swatch.attr('title') || '').trim();

//   const shadeImage = $swatch.attr('data-variant-image');

//   console.log('🎨 Selected Shade:', shadeTitle);
//   console.log('🖼️ Variant Image:', shadeImage);

//   /* -------------------------------------------------------
//      PRODUCT CARD
//   ------------------------------------------------------- */

//   const $product = $swatch.closest('.ProductItem');

//   if (!$product.length) {

//     console.log('❌ Product card not found');

//     return;
//   }

//   console.log('📦 Product:', $product[0]);


//   /* -------------------------------------------------------
//      UPDATE VARIANT TITLE
//   ------------------------------------------------------- */

//   const $variantTitle =
//     $product.find('.cstm-variant').first();

//   if ($variantTitle.length) {

//     $variantTitle.text(shadeTitle);

//   }


//   /* -------------------------------------------------------
//      ACTIVE SWATCH
//   ------------------------------------------------------- */

//   $product
//     .find('.color-swatch')
//     .removeClass('active-swatch');

//   $swatch.addClass('active-swatch');


//   /* -------------------------------------------------------
//      CHECK IMAGE
//   ------------------------------------------------------- */

//   if (!shadeImage) {

//     console.log(
//       '❌ No variant image available for:',
//       shadeTitle
//     );

//     console.log(
//       '⚠️ This variant may not have an image assigned in Shopify'
//     );

//     return;
//   }


//   /* -------------------------------------------------------
//      FIND HOMEPAGE PRODUCT IMAGES
//   ------------------------------------------------------- */

//   const $images =
//     $product.find(
//       '.ProductItem__ImageWrapper img.ProductItem__Image'
//     );

//   console.log(
//     '🖼️ Product Images Found:',
//     $images.length
//   );


//   if (!$images.length) {

//     console.log(
//       '❌ Product image not found'
//     );

//     return;
//   }


//   /* -------------------------------------------------------
//      MAIN / HERO IMAGE
//   ------------------------------------------------------- */

//   const $mainImage =
//     $images
//       .not('.ProductItem__Image--alternate')
//       .first();


//   /* -------------------------------------------------------
//      IF MAIN IMAGE EXISTS
//   ------------------------------------------------------- */

//   if ($mainImage.length) {

//     $mainImage.attr(
//       'src',
//       shadeImage
//     );

//     $mainImage.attr(
//       'data-src',
//       shadeImage
//     );

//     $mainImage.attr(
//       'data-loaded',
//       'true'
//     );

//     console.log(
//       '✅ Main image changed'
//     );

//   }


//   /* -------------------------------------------------------
//      ALTERNATE IMAGE
     
//      We can also update alternate image so hover
//      doesn't immediately show old shade.
//   ------------------------------------------------------- */

//   const $alternateImage =
//     $images
//       .filter('.ProductItem__Image--alternate')
//       .first();


//   if ($alternateImage.length) {

//     $alternateImage.attr(
//       'src',
//       shadeImage
//     );

//     $alternateImage.attr(
//       'data-src',
//       shadeImage
//     );

//     $alternateImage.attr(
//       'data-loaded',
//       'true'
//     );

//     console.log(
//       '✅ Alternate image changed'
//     );

//   }


//   /* -------------------------------------------------------
//      REMOVE LAZY LOAD STATE
//   ------------------------------------------------------- */

//   $product
//     .find('.ProductItem__Image')
//     .attr(
//       'data-loaded',
//       'true'
//     );


//   console.log(
//     '🎯 HOMEPAGE SHADE IMAGE UPDATED:',
//     shadeTitle
//   );

//   console.log('================================');

// });
  $(document).on('click', '.slick-arrow', function (e) {
    e.preventDefault();
    e.stopPropagation();
  });

});


// here we write a code for variant title 

 $(document).on('click', '.color-swatch', function () {
  let titlevalue = $(this).attr('title');
  let variantprice = $(this).attr('product-variant-price');
  let variantcompareprice = $(this).attr('product-variant-compare-price');
  let variantdiscount = $(this).attr('product-variant-discount');
  let $product = $(this).closest('.ProductItem');
  let cstmVariantattr = $product.find('.cstm-variant');
  cstmVariantattr.text(titlevalue);
  let $cstmprice = $product.find('.ProductItem__Price.3');
  let $cstmcompareprice = $product.find('.ProductItem__Price.4');
  let $cstmdiscount = $product.find('.ProductMeta__Price.Price--discount');

  if (variantcompareprice && variantcompareprice.trim() !== '') {
    $cstmprice.text(variantprice).show();
    $cstmcompareprice.text(variantcompareprice).show();
    $cstmdiscount.text(variantdiscount).hide();
  } else {
    $cstmprice.text(variantprice).show();
    $cstmcompareprice.hide();
    $cstmdiscount.hide();
  }
});

// active filter functionality
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.ActiveFilters__Tag');
  if (!btn) return;

  const param = btn.dataset.filterParam;
  const value = btn.dataset.filterValue;

  const selector =
    'input[name="' + CSS.escape(param) + '"][value="' + CSS.escape(value) + '"]';

  const checkbox = document.querySelector(selector);

  if (checkbox) {
    checkbox.checked = false;
    checkbox.dispatchEvent(new Event('change', { bubbles: true }));
  }
});



  $(document).on("click", ".Popover__Value[data-action='select-value']", function () {
    var selectedValue = $(this).data("value");
    var selectedText = $(this).text().trim();
    $(".selected-sort-text").text(selectedText);
    setTimeout(() => {
        $("[data-action='close-popover']").trigger("click");
    }, 200);
});


// JS added to show loader image on PLP ATC button click.

document.addEventListener("click", function (e) {
  const atcButton = e.target.closest(".addtocart_button");
  if (!atcButton) return;

  const atcText = atcButton.querySelector(".atc-text");
  const atcLoader = atcButton.querySelector(".atc-loader");

  if (!atcText || !atcLoader) return;

  // show loader
  atcText.style.display = "none";
  atcLoader.style.display = "inline-block";
  atcButton.classList.add("new-padding");
  atcButton.setAttribute("disabled", "disabled");

  // reset after 2 seconds
  setTimeout(function () {
    atcLoader.style.display = "none";
    atcText.style.display = "inline-block";
    atcButton.classList.remove("new-padding");
    atcButton.removeAttribute("disabled");
  }, 2000);
});



